import { animate, state, style, transition, trigger } from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Route } from '@models/route';
import { NewconService } from '@services/newcon.service';
import { Router } from '@angular/router';
import { MatDialog } from "@angular/material/dialog";


@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrl: './vertical.component.scss',
  animations:[
    trigger('slideVertical', [
      state('*', style( {height: 0} )),
      state('show', style( {height: '*'} )),
      transition('* => *', [animate('600ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
    ])
  ]
})
export class VerticalComponent {
  @Output() emitCloseMenu: EventEmitter<void> = new EventEmitter();
  @Input() dataSource: MatTreeNestedDataSource<Route>
  @Input() eixo: string;

  public treeControl = new NestedTreeControl<Route>(node => node.children);
  public isExpanded: boolean = false;

  constructor(private readonly _router: Router,
              private readonly _newconService: NewconService,
            private readonly _dialog: MatDialog) { }

  public hasChild = (_: number, node: Route) => !!node.children && node.children.length > 0;

  public returnDataCy(eixo: string, name: string): string {
    return "menu-" + eixo + "-" + name
  }

  public handleNodeClick(node: Route): void {
    if (node.action) {
      node.action(this._newconService, this._dialog);
    } else if (node.path) {
        this._router.navigate([node.path]);
    }

    this.closeMenu();
  }
  public closeMenu(): void {
    this.emitCloseMenu.emit()
  }

}
